import { render, staticRenderFns } from "./works-carousel.vue?vue&type=template&id=0a508b5e"
import script from "./works-carousel.vue?vue&type=script&lang=js"
export * from "./works-carousel.vue?vue&type=script&lang=js"
import style0 from "./works-carousel.vue?vue&type=style&index=0&id=0a508b5e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports